import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type CryptoAsset = 'BTC' | 'ETH' | 'SOL'
export type DayOffset = 0 | 1 | 2 // today, tomorrow, +2

interface GameState {
  currentCrypto: CryptoAsset
  selectedDay: DayOffset
  streak: number
  pnl: number
  lastBetTimestamp: number | null
  confettiAt: number | null
  setCurrentCrypto: (crypto: CryptoAsset) => void
  setSelectedDay: (day: DayOffset) => void
  incrementStreak: () => void
  resetStreak: () => void
  addPnl: (delta: number) => void
  setLastBetTimestamp: (ts: number | null) => void
  triggerConfetti: () => void
  clearConfetti: () => void
}

export const useGameStore = create<GameState>()(
  persist(
    (set) => ({
      currentCrypto: 'BTC',
      selectedDay: 0,
      streak: 0,
      pnl: 0,
      lastBetTimestamp: null,
      confettiAt: null,

      setCurrentCrypto: (crypto) => set({ currentCrypto: crypto }),
      setSelectedDay: (day) => set({ selectedDay: day }),
      incrementStreak: () => set((s) => ({ streak: s.streak + 1 })),
      resetStreak: () => set({ streak: 0 }),
      addPnl: (delta) => set((s) => ({ pnl: s.pnl + delta })),
      setLastBetTimestamp: (ts) => set({ lastBetTimestamp: ts }),
      triggerConfetti: () => set({ confettiAt: Date.now() }),
      clearConfetti: () => set({ confettiAt: null }),
    }),
    {
      name: 'polystrike-game',
      version: 5,
      partialize: (s) => ({
        currentCrypto: s.currentCrypto,
        selectedDay: s.selectedDay,
        streak: s.streak,
        pnl: s.pnl,
        lastBetTimestamp: s.lastBetTimestamp,
      }),
    }
  )
)
